import { render, staticRenderFns } from "./p295_profitbadge.vue?vue&type=template&id=2a5ecfaa"
import script from "./p295_profitbadge.vue?vue&type=script&lang=js"
export * from "./p295_profitbadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports